<script setup lang="ts">
import Logo from '@/assets/logo.svg?component';
import { useAuth0 } from '@auth0/auth0-vue';
import { dir } from 'opfs-tools';
import { computed } from 'vue';
import Avatar from 'vue-boring-avatars';

const { user, idTokenClaims, logout } = useAuth0();

const isAdmin = computed(() => {
  return idTokenClaims.value?.['eyesoft/roles']?.includes('Admin');
});

const logoutCb = async () => {
  await logout({ logoutParams: { returnTo: window.location.origin } });
};

const clearCache = async () => {
  await dir('/cache').remove();
};
</script>

<template>
  <div class="h-100 d-flex flex-column flex-shrink-0 p-3 text-white bg-dark">
    <a href="/" class="d-flex align-items-center mb-3 mb-md-0 text-align-center text-white text-decoration-none">
      <Logo class="logo" />
    </a>
    <hr />
    <ul class="nav nav-pills d-flex flex-column h-100">
      <li class="nav-item" data-cy="sidebar.orders">
        <RouterLink to="/orders" active-class="active" class="nav-link text-white">
          <font-awesome-icon icon="fa-solid fa-shopping-cart" class="icon" />
          <span>Commandes</span>
        </RouterLink>
      </li>
      <li class="nav-item" data-cy="sidebar.toolbox">
        <RouterLink to="/toolbox" active-class="active" class="nav-link text-white">
          <font-awesome-icon icon="fa-solid fa-toolbox" class="icon" />
          <span>Toolbox</span>
        </RouterLink>
      </li>
      <li v-if="isAdmin" class="nav-item mt-auto" data-cy="sidebar.admin">
        <RouterLink to="/admin" active-class="active" class="nav-link text-white">
          <font-awesome-icon icon="fa-solid fa-gear" class="icon" />
          <span>Administration</span>
        </RouterLink>
      </li>
    </ul>
    <hr />
    <div class="dropdown">
      <a
        id="dropdownUser1"
        href="#"
        class="d-flex align-items-center text-white text-decoration-none dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Avatar class="me-2" :size="32" variant="beam" :name="user?.email" />
        <strong>{{ user?.email }}</strong>
      </a>
      <ul class="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdownUser1" style="">
        <li>
          <button type="button" class="btn dropdown-item btn-link" @click="clearCache">Nettoyer le cache</button>
        </li>
        <li>
          <button type="button" class="btn dropdown-item btn-link" @click="logoutCb">Se déconnecter</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.navbar {
  width: 100%;
  height: 100%;
}

.logo {
  width: 100%;
  max-width: 250px;
}

.icon {
  margin-right: 0.5em;
}
</style>
